import Vue from 'vue';
import App from './TrackingApp.vue';

window.Apps = window.Apps || {};
Apps.initTracking = function (glassItemData, initialTranslations) {
    if ($('#tracking-app-' + glassItemData.id).length > 0) {
        var data = {
            glassItemData,
            initialTranslations
        }
        new Vue({
            el: '#tracking-app-' + glassItemData.id,
            data,
            render: h => h(App)
        })
    }
}